import React from 'react';
import { useLoaderData } from 'react-router-dom';
import Question from './Question';

const QuizePage = () => {
    const quazeDetail = useLoaderData()
    const { questions } = quazeDetail.data;

    return (
        <div className='py-10 lg:w-3/4 mx-auto'>
            {
                questions.map(question => <Question
                    key={question.id}
                    questionA={question}
                ></Question>)
            }
        </div>
    );
};

export default QuizePage;